import React from 'react';
import styles from './index.module.scss';

const CustomCard = ({ content }: { content: string | null }) => {
  return (
    <div className={styles.cardContainer}> 
      <p className={styles.card_content}>{content ? content : "You will be redirected to Razorpay payment gateway upon clicking ‘submit’"}</p>
    </div>
  );
}
export default CustomCard;